import {Form, Col, Row} from '@deere/ux.uxframe-react'
import { Button } from "@deere/fuel-react"
import React from 'react'
import { useHistory } from "react-router";
import { SCBM_STATES_CAMPAIGN, SCBM_USER_TYPE, CTPAT, CRS_REQUEST_STATUS_OBJ, AEU, COC } from '../../utils/surveyLiterals'
import { useTranslation } from "react-i18next";
import { useUserInfo } from '../../providers/userProvider'
import { useOktaAuth } from '@okta/okta-react'
import { deleteResponseFromAssignment } from '../../services/campaign.service';
import { useLocation } from "react-router-dom";
import { isInterfactory } from '../../utils/utils';

function disableButtons(campaignAssigned, userInfo, previous,surveyType){
    if(campaignAssigned && Array.isArray(campaignAssigned.assignments) && campaignAssigned.assignments.length > 0) {

        if(userInfo.userType===SCBM_USER_TYPE.SUPPLIER && surveyType===COC
            && campaignAssigned.status !== SCBM_STATES_CAMPAIGN.CLOSED ){ // For COC - Completed requests are supposed to be accessible to the suppliers and they can resubmit it.
            return false
        }
        return campaignAssigned.assignments[0].status === CRS_REQUEST_STATUS_OBJ.COMPLETE ||
                     campaignAssigned.status === SCBM_STATES_CAMPAIGN.CLOSED || (userInfo.userType === SCBM_USER_TYPE.SALARY && !isInterfactory(surveyType) && previous !== '/' )
                     || previous === '/details'
    }
    return true;
}

function disableButtonNonOkta(campaignAssigned, previous, surveyType){
    if(campaignAssigned && Array.isArray(campaignAssigned.assignments) && campaignAssigned.assignments.length > 0) {   
        if(surveyType===COC && campaignAssigned.status !== SCBM_STATES_CAMPAIGN.CLOSED){  // For COC - Completed requests are supposed to be accessible to the suppliers and they can resubmit it.
            return false;
        }
        return campaignAssigned.assignments[0].status === CRS_REQUEST_STATUS_OBJ.COMPLETE || campaignAssigned.status === SCBM_STATES_CAMPAIGN.CLOSED || previous === '/details'
    }
    return true;
}

function shouldRenderDeleteResponse(campaignAssigned,userInfo,survey,campaign,answers){
    if(campaignAssigned && Array.isArray(campaignAssigned.assignments) && campaignAssigned.assignments.length > 0 && answers.length > 0) {
        return survey.code === AEU && campaign.status === SCBM_STATES_CAMPAIGN.OPEN && userInfo?.roles.includes(survey.adminRole)
    }
    return false;
}

export default function ActionsPage({submitSurveyFn,setShowAgreement,campaignAssig,survey,setStatusSubmit,campaign,answers, setShowAEUDisclaimer}){
    const userInfo = useUserInfo();
    const history = useHistory();
    const location = useLocation();
    const { t } = useTranslation();
    const { authState } = useOktaAuth();
    const shouldShowDeleteResponse = shouldRenderDeleteResponse(campaignAssig,userInfo,survey,campaign,answers);

    let isAuthMethodOkta = authState && authState.isAuthenticated ? true : false;

    const submitSurveyResponses = () =>{
        switch (survey.code) {
            case CTPAT:
                setShowAgreement(true);
                break;
            case AEU:
                setShowAEUDisclaimer(true);
                break;
            default:
                submitSurveyFn();
                break;
        }
    }

    const shouldDisableButton = () => {
        let shouldDisable = false;
        if(isAuthMethodOkta){
            if(!campaignAssig || disableButtons(campaignAssig, userInfo,location.state.previous,survey.code))   shouldDisable = true;
        }else{
            if(!campaignAssig || disableButtonNonOkta(campaignAssig,location.state.previous,survey.code))  shouldDisable = true;
        }
        return shouldDisable;
    }

    const deleteAeuResponse =  () =>{
        deleteResponseFromAssignment(campaignAssig.assignments[0].id, authState.accessToken.accessToken).then((deleted) => {
            if (deleted && deleted >= 0) {
                history.push({
                    pathname: '/',
                    state: { 
                        previous: "/"
                    }
                });
            }else{
                setStatusSubmit({ status: true, message: 'Error deleting response!', label: 'Danger:', variant: 'danger' });
                window.scrollTo(0, 0);
            }
        }).catch(err => { 
            console.log(err)
        });

    }

    return campaignAssig? (<>
            <Row className="card position-sticky fixed-bottom d-print-none">
                <Row className="card position-sticky fixed-bottom">
                    <Col md="24" className="card-body p-3 text-right">
                        <Form.Group as={Col} className="align-right">  
                            <Button variant="primary" className="float-right" onClick={submitSurveyResponses} disabled={shouldDisableButton()}>{t('btn_review_submit')}</Button>
                            <Button variant="secondary" className="float-right mr-2" onClick={e =>history.goBack()} disabled={shouldDisableButton()}>{t('btn_review_back_to_edit')}</Button> 
                            {shouldShowDeleteResponse && <Button variant="secondary" className="float-right mr-2" onClick={deleteAeuResponse}>{t('btn_review_delete')}</Button> }
                        </Form.Group>
                    </Col>
                </Row>
            </Row>
            </>) : <></>
}   